import ApiCalls from "../../config/apiCalls";
import Headers from "../../config/headers";
import LocalStorageFunc from "../../helpers/localStorageFunc";
import { keyMapsMutation } from "../../helpers/storeKeys";
import {
  cms_platform_id,
  cms_lang_id,
  siteContext,
} from "../../config/apiEndpoints";

export default {
  namespaced: true,
  state: {
    profileData: {
      name:
        LocalStorageFunc.getUserData()?.userData?.firstName &&
        LocalStorageFunc.getUserData()?.userData?.lastName
          ? `${LocalStorageFunc.getUserData()?.userData?.firstName} ${
              LocalStorageFunc.getUserData()?.userData?.lastName
            }`
          : LocalStorageFunc.getUserData()?.userData?.firstName
          ? LocalStorageFunc.getUserData()?.userData?.firstName
          : "Hey, Hong's Mate!",
      email: LocalStorageFunc.getUserData()?.userData?.email || "",
    },
    showProfileModal: false,
    showEditProfileModal: false,
    menuGroupsData: [],
  },
  getters: {
    getProfileData: (state) => {
      return state.profileData;
    },
    getShowProfileModal(state) {
      return state.showProfileModal;
    },
    getShowEditProfileModal(state) {
      return state.showEditProfileModal;
    },
  },
  mutations: {
    updateProfileData(state, payload) {
      state.profileData = payload;
      let userInfo = LocalStorageFunc.getUserData();
      userInfo.userData.email = payload.email;
      userInfo.userData.firstName = payload.firstName;
      userInfo.userData.lastName = payload.lastName;
      LocalStorageFunc.setUserInfoData(userInfo);
    },
    updateShowProfileModal(state, payload) {
      state.showProfileModal = payload;
    },
    updateShowEditProfileModal(state, payload) {
      state.showEditProfileModal = payload;
    },
    updateMenuGroupsData(state, payload) {
      state.menuGroupsData = payload;
    },
  },
  actions: {
    hamburgerItemsApi({ commit }, payload) {
      commit(keyMapsMutation.UPDATE_LOADING_STATE, true, {
        root: true,
      });
      ApiCalls.HAMBURGER_ITEMS_API({
        headers: Headers(),
        payload: {
          storeId: LocalStorageFunc.storeId(),
          langId: cms_lang_id,
          platformId: cms_platform_id,
          site: siteContext,
        },
      })
        .then(function (response) {
          if (response?.data) {
            commit("updateMenuGroupsData", response.data);
          }
          commit(keyMapsMutation.UPDATE_LOADING_STATE, false, {
            root: true,
          });
        })
        .catch(function (error) {
          commit(keyMapsMutation.UPDATE_LOADING_STATE, false, {
            root: true,
          });
        });
    },
  },
};
